class LoginIframeComponent {
    public loginIframe!: HTMLIFrameElement;
    constructor() { }

    public onDomLoaded() {
        this.loginIframe = document.getElementById("progresoLoginIframe") as HTMLIFrameElement;

        window.addEventListener("message", (event) => {
            if (this.loginIframe == null)
                return;

            if (event.data?.source != "e2r")
                return;

            switch (event.data?.action) {
                case "login-success":
                    document.cookie = "progresoLogin=true; path=/"
                    window.location.href = "/";
                    break;
            }
        })
    }
}

const component = new LoginIframeComponent();

export default component;

document.addEventListener("DOMContentLoaded", () => component.onDomLoaded(), { once: true });
